import { render, staticRenderFns } from "./ShiftLeads.vue?vue&type=template&id=30ac2916&"
import script from "./ShiftLeads.vue?vue&type=script&lang=js&"
export * from "./ShiftLeads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports